export default "__VITE_ASSET__DRa2mV5X__"